import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddIcon from '@material-ui/icons/Add';
import Button from 'components/common/Button';
import Typography from '@material-ui/core/Typography';
import { Query } from 'react-apollo';
import Spin from 'components/common/Spin';
import { GET_STUDENTS } from 'graphql/guardian';
import StudentCard from 'components/StudentCard';
import Helmet from "react-helmet";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const useStyles = makeStyles((theme) => ({
  addIcon: {
    width: 40,
    height: 40,
  },
  cardContent: {
    textAlign: 'center',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  }
}));

const Students = () => {
  const classes = useStyles();

  return (
    <Query
      query={GET_STUDENTS}
      fetchPolicy="cache-and-network"
    >
      {({ data }) => {
        if (!data) return <Spin spinning />;

        return (
          <Box>
            <Helmet title="Students" />
            <Box marginBottom={2} display="flex" justifyContent="flex-end">
              <Link to={`/purchase`}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />}>Add Student</Button>
              </Link>
            </Box>
            <Grid container spacing={4}>
              {data.students.map((s) => (
                <Grid item sm={12} md={6} xl={4}>
                  <StudentCard student={s} key={s.user_id} role='parent'/>
                </Grid>
              ))}
            </Grid>
          </Box>
        );
      }}
    </Query>
  );
};

export default Students;
